import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";
import { SURFACE, TEXT } from "../../dark-theme/palette";
import { trackEvent } from "../../services/GoogleAnalytics";

export default function EmailVerified() {
    const navigate = useNavigate();

    useEffect(() => {
        trackEvent("entered", { name: "EmailVerified" });
    }, []);

    return (
        <Box sx={{ flexGrow: 1, p: 3 }}>
            <Grid container spacing={4}>
                <Grid
                    size={{ xs: 12 }}
                    sx={{
                        color: TEXT.primary,
                        backgroundColor: SURFACE.card,
                        display: "flex",
                        justifyContent: "flex-start",
                        textAlign: "left",
                        p: 4,
                        borderRadius: 2,
                        boxShadow: 1,
                    }}
                >
                    <Box sx={{ width: "100%" }}>
                        <Typography
                            variant="h3"
                            sx={{
                                color: "#3BA666",
                                fontSize: { xs: "32px", md: "48px" },
                                fontWeight: 600,
                                mb: 4,
                            }}
                        >
                            Thank you for verifying your email address!
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                color: TEXT.primary,
                                fontSize: "18px",
                                lineHeight: 1.8,
                                mb: 2,
                            }}
                        >
                            Your email has been successfully verified. You can now enjoy all the features of {process.env.REACT_APP_SITE_NAME}.
                        </Typography>
                        <Typography
                            variant="body1"
                            sx={{
                                color: "#3BA666",
                                fontSize: "18px",
                                fontWeight: 600,
                                mt: 3,
                            }}
                        >
                            Warm regards,<br />
                            {process.env.REACT_APP_SITE_NAME} Team
                        </Typography>
                        <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
                            <Button
                                variant="contained"
                                onClick={() => navigate("/")}
                                sx={{
                                    backgroundColor: "#3BA666",
                                    color: "white",
                                    textTransform: "none",
                                    fontWeight: 600,
                                    px: 4,
                                    py: 1.5,
                                    "&:hover": {
                                        backgroundColor: "#2e7d32",
                                    },
                                }}
                            >
                                Home
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
